let env = process.env.NODE_ENV

const host = env === 'development' ? 'http://localhost:3001/' : env === 'production' ? 'http://dxs.moe.gov.cn/' : 'http://localhost:8090/'
const hostaudio = env === 'development' ? window.location.origin+'/' : env === 'production' ? window.location.origin+ '/xyh/': window.location.origin
const root = env === 'development' ? '' : ''
const secretId = env === 'production' ? 'AKIDiJjz3vMbP1SgknteIk270g9QvMbjpXGo' : 'AKIDLcjeNxMuAEIG3eeRYSG7wc8ukS4HKM9u'
    // const secretId = env === 'production' ? 'AKIDLcjeNxMuAEIG3eeRYSG7wc8ukS4HKM9u' :'AKIDLcjeNxMuAEIG3eeRYSG7wc8ukS4HKM9u'
const secretKey = env === 'production' ? 'UmsnV4Sgw65rRE0e6OUTGtK3viKky4yh' : 'thKl5EBGCzb1GJApIgstiLm2Tnwa5OUN'
    // const secretKey = env === 'production' ? 'thKl5EBGCzb1GJApIgstiLm2Tnwa5OUN' : 'thKl5EBGCzb1GJApIgstiLm2Tnwa5OUN'
const catalogList = [{ 'title': '时政', 'id': '15702' }, { 'title': '财经', 'id': '15703' }, { 'title': '社会', 'id': '15704' }, { 'title': '国际', 'id': '15706' }, { 'title': '评论', 'id': '15707' }, { 'title': '科技', 'id': '15709' }, { 'title': '文化', 'id': '15708' }, { 'title': '体育', 'id': '15710' }]
const siteName = '校园号平台'
const ssoRoot = 'https://dxs.moe.gov.cn/front/front/sso/zmtLogin'
const studios= [ //校园号类型
    { value: 0, label: '全部' },
    { value: 1, label: '专栏号' },
    { value: 2, label: '政务号' },
    { value: 3, label: '企业号' },
    { value: 4, label: '机构号' },
    { value: 5, label: '媒体号' },
    { value: 6, label: '高校号' }
]
let config = {
    env: env,
    // host: '/',
    host: host,
    hostaudio:hostaudio,
    // root: root,
    serverRoot: '/zmt/',
    secretId: secretId,
    secretKey: secretKey,
    catalogList: catalogList,
    siteName: siteName,
    ssoRoot: ssoRoot,
    studios:studios
}
export default config


// WEBPACK FOOTER //
// ./src/config/index.js